export const SearchPresetTypes = {
    dealer: 1,
    common: 2,
    user: 3,
    tag: 4
};
